<template>
	<div class="notification">
		<h1> {{ message }} </h1>
	</div>
</template>


<script>
	export default {
		props:['book_item'],

		data () {
			return {
				message: 'Hello world'
			}
		},
		computed: {

		},

		methods:{

		}
	}
</script>